import React from "react";
import "./PointsTable.css";
import {useFormikContext} from "formik";
import {WalkMap} from "./types";
import PointItem from "./PointItem";

const PointsTable = () => {
  const {values: walkMap} = useFormikContext<WalkMap>();

  return (
    <ul className="PointsTable">
      {walkMap.points.map((point, i) => (
        <PointItem key={i} point={point} index={i} />
      ))}
    </ul>
  );
};

export default PointsTable;
